import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { useCallback, useEffect, useState } from 'preact/compat';
import CurrencyInput from 'react-currency-input-field';
import clsx from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import sanitizeTitle from '@widgets/shared/sanitizeTitle';
import FormError from '@enquiryForm/components/FormError';
export default function AmountSelector(props) {
    const { name, options, labelAttrs } = props;
    const { control } = useFormContext();
    const { field: { onChange, value }, fieldState: { error, invalid }, } = useController({
        name,
        control,
    });
    const [selectedAmount, setSelectedAmount] = useState('0');
    const [customAmount, setCustomAmount] = useState('');
    const removeAppendages = useCallback((rawValue) => rawValue.replace('£', ''), []);
    const handleValueChanged = useCallback(() => {
        if (selectedAmount === 'other') {
            return onChange(parseFloat((customAmount && customAmount.length) ? customAmount : '5'));
        }
        return onChange(parseFloat(selectedAmount));
    }, [customAmount, onChange, selectedAmount]);
    const handleCustomValueChanged = useCallback((newCustomValue) => {
        if (newCustomValue) {
            let parsedValue = parseFloat(`${newCustomValue}`);
            // if (parsedValue < 5) {
            //   parsedValue = 5;
            // }
            if (parsedValue > 1000) {
                parsedValue = 1000;
            }
            return setCustomAmount(`${parsedValue}`);
        }
        return setCustomAmount('');
    }, [setCustomAmount]);
    useEffect(handleValueChanged, [customAmount, selectedAmount, handleValueChanged]);
    const wrapperClassName = clsx([
        'amount-selector',
        invalid ? 'has-error' : null,
    ]);
    return (_jsxs("div", { className: wrapperClassName, children: [_jsx("input", { type: "hidden", name: name, value: value }), _jsx(FormLabel, { ...labelAttrs }), _jsx("ul", { className: "amount-selector__inputs amounts", children: options.map(({ label, value: optionValue }) => (_jsx("li", { className: "amounts__item", children: _jsxs("div", { className: "amount", children: [_jsx("input", { id: `option-${name}-${sanitizeTitle(optionValue)}`, type: "radio", value: optionValue, checked: optionValue === selectedAmount, onChange: () => setSelectedAmount(optionValue), className: "amount__input" }), _jsx("label", { htmlFor: `option-${name}-${sanitizeTitle(optionValue)}`, className: "amount__label", children: label })] }) }))) }), (selectedAmount === 'other') && (_jsx("div", { className: "amount-selector__custom", children: _jsxs("div", { className: "form__group", children: [_jsx("label", { htmlFor: `${name}-custom`, className: "form__label", children: "Enter a specific amount" }), _jsx(CurrencyInput, { id: `${name}-custom`, allowNegativeValue: false, value: customAmount ?? '', type: "tel", prefix: "\u00A3", placeholder: "Min \u00A35 - Max \u00A31000", onValueChange: handleCustomValueChanged, transformRawValue: removeAppendages, className: "form__control" }), error && (_jsx(FormError, { children: error?.message }))] }) }))] }));
}
